export interface RefSeq2 {
    idrefseq2_ID: number;
    accession: string | null;
    gene_size: string | null;
    gene_name1: string | null;
    gene_name2: string | null;
    encodes: string | null;
    definition: string;
    chrom: string | null;
    chrom_map: string | null;
    refseq_desc: string | null;
}

export interface ChromosomeDistribution {
    chrom: string;
    count: number;
}

export const defaultRefSeq2: RefSeq2 = {
    idrefseq2_ID: 0,
    accession: null,
    gene_size: null,
    gene_name1: null,
    gene_name2: null,
    encodes: null,
    definition: '',
    chrom: null,
    chrom_map: null,
    refseq_desc: null
};